// src/lib/googleAds.js
//
// The Google Ads pages' own helpers. The HTTP part lives in ./api, which every
// page shares; what is left here is specific to Google Ads — micros, the
// account's currency, and where the consent flow starts.

import { apiFetch, describeError } from './api';

/**
 * Fetch against the ads backend (/api/google, /api/auth/google).
 *
 * A thin alias so these pages read as talking to one service; nginx proxies
 * both prefixes to the leads-ads container.
 */
export const adsApi = apiFetch;

export { describeError };

/** Micros are millionths of the account's currency unit. */
export function fromMicros(micros) {
  const n = Number(micros);
  return Number.isFinite(n) ? n / 1_000_000 : 0;
}

export function formatMoney(amount, currency = 'INR') {
  const n = Number(amount);
  if (!Number.isFinite(n)) return '—';
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency,
      maximumFractionDigits: 2,
    }).format(n);
  } catch {
    // An account can report a currency Intl does not know; showing the code
    // beside the number beats throwing inside a render.
    return `${n.toFixed(2)} ${currency}`;
  }
}

/**
 * Where the browser goes to start Google's consent flow.
 *
 * A navigation rather than a fetch: the response is a redirect to
 * accounts.google.com, which fetch cannot follow usefully. The platform access
 * cookie rides along because it is a top-level GET.
 */
export function connectUrl(next = '/google-ads') {
  return `/api/auth/google/login?next=${encodeURIComponent(next)}`;
}
